
//=============================================================================
// Attention! This file is generated
//   by /home/timstraube/Programme/Spinnax/freak/freak/freak_tools/src/freak_tools/_com.py
// Only edit within the protected regions!
//=============================================================================

//-----------------------------------------------------------------------------
export const SIZE_PACKET = 240;

export const SIZE_LOG_TEXT = 217;

export const COUNT_RECORD_SAMPLE = 4;

export const LOG_LEVEL_FATAL = 60;

export const LOG_LEVEL_CRITICAL = 50;

export const LOG_LEVEL_ERROR = 40;

export const LOG_LEVEL_WARNING = 30;

export const LOG_LEVEL_LOG = 25;

export const LOG_LEVEL_INFO = 20;

export const LOG_LEVEL_DEBUG = 10;

export const LOG_LEVEL_NOT_SET = 0;

export const STATUS_OK = 0;

export const STATUS_NOT_FOUND = 10;

export const STATUS_NOT_READY = 20;

export const STATUS_CONFIGURATION_FAILED = 30;

export const STATUS_RESET_FAILED = 40;

export const STATUS_THREAD_CREATION_FAILED = 50;

export const STATUS_ACTION_FAILED = 60;

export const STATUS_NOT_INITIALIZED = 255;
